import {BaseModuleProps} from "../../../infrastructure/models/props/base-module-props";
import {ScoresListWidgetController} from "../scores-list-widget.controller";
import {SCORES_LIST_WIDGET} from "../scores-list-widget.consts";

export class ScoresListWidgetProps extends BaseModuleProps {
  controller: ScoresListWidgetController;
  isLive: Boolean;
  date: Date;
  type: SCORES_LIST_WIDGET.TYPES;
}
